import {
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Client } from '../../../core/types/client';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../../../core/services/client.service';
import { takeUntil, filter, mergeMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ErrorService } from '../../../core/services/error.service';

@Component({
  selector: 'itfg-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.scss'],
  standalone: false
})
export class KycComponent implements OnInit, OnDestroy {

  _unsubscribe: Subject<void> = new Subject<void>();
  @Input() client: Client;

  constructor(
    private clientService: ClientService,
    private route: ActivatedRoute,
    private errorService: ErrorService,
  ) { }

  ngOnInit() {
    this.route.paramMap
      .pipe(
        filter((params: ParamMap) => typeof params.get('id') === 'string'),
        mergeMap((params: ParamMap) =>
          this.clientService.getClientById(Number(params.get('id')))
        )
      )
      .pipe(takeUntil(this._unsubscribe))
      .subscribe(
        client => {
          this.client = client;
        },
        error => {
          this.errorService.handleError(error, this.route.data);
        }
      );
  }



  ngOnDestroy() {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}

